import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { fetchProtectedFile, protectedFileId } from '../Services/AuthenticatedFiles';
import { useSessionStore } from '../Stores/Session';

/** Static rich-text rendering does not run Tiptap node views. Authenticate media here too. */
const ProtectedMessageHtml = forwardRef<HTMLDivElement, { html: string; className?: string }>(({ html, className }, ref) => {
  const root = useRef<HTMLDivElement>(null);
  useImperativeHandle(ref, () => root.current!);
  const session = useSessionStore((state) => state.session);
  useEffect(() => {
    let disposed = false;
    const urls: string[] = [];
    const elements = root.current?.querySelectorAll<HTMLElement>('img, audio, video, source') ?? [];
    elements.forEach((element) => {
      const url = element.getAttribute('data-protected-file') || element.getAttribute('src');
      if (!url || !protectedFileId(url)) return;
      element.setAttribute('data-protected-file', url);
      element.removeAttribute('src');
      element.setAttribute('aria-label', 'Sign in to view attachment');
      if (!session?.fileAccessToken) return;
      fetchProtectedFile(url).then((r) => r.blob()).then((blob) => {
        if (disposed) return;
        const expectedType = element.tagName === 'IMG' ? 'image/' : element.tagName === 'AUDIO' ? 'audio/' : element.tagName === 'VIDEO' ? 'video/' : '';
        if ((expectedType && !blob.type.startsWith(expectedType)) || blob.type.includes('svg')) return;
        const objectUrl = URL.createObjectURL(blob); urls.push(objectUrl);
        element.setAttribute('src', objectUrl);
        element.removeAttribute('aria-label');
        if (element.tagName === 'SOURCE') (element.parentElement as HTMLMediaElement)?.load?.();
      }).catch(() => {});
    });
    return () => { disposed = true; urls.forEach((url) => URL.revokeObjectURL(url)); elements.forEach((e) => { if (e.hasAttribute('data-protected-file')) e.removeAttribute('src'); }); };
  }, [html, session?.fileAccessToken, session?.gleapId]);
  return <div ref={root} className={className} dangerouslySetInnerHTML={{ __html: html }} />;
});
export default ProtectedMessageHtml;
